/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getEstadosGlobales,
} from 'api/catalogos';
import Table from 'components/Table';
import {
  getEvaluacionesAsistencia,
} from 'api/catalogos/TiposDeEvaluacionAsistencia';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIncidenciaCarga,
  deleteIncidenciaCarga,
  getIncidenciaCarga, getIncidenciasCargas, getIncidenciasCargasPag, patchIncidenciaCarga, postIncidenciaCarga,
} from 'api/configuraciones/clock/Incidencias/IncidenciaCarga';
import { formatReceived } from 'utils/formatValues';
import moment from 'moment/moment';
import { getRelojesChecadores } from 'api/catalogos/Clock/TipoRelojChecador';

export const cargaConfigPermission = {
  permissionModel: 'incidenciaCarga',
  catalogsModels: [],
  tabsModels: [],
};

const CargaConfigReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [relojesChecadores, setRelojesChecadores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [isFechaRegistro, setFechaRegistro] = useState(false);

  const formInstances = [
    form,
  ];

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIncidenciasCargasPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const fetchData = async () => {
    setLoading(true);
    const _data = await getIncidenciasCargas({ estados_globales: ESTATUS_AUTORIZADO });
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _relojesChecadores,
        _data,
        _estados,
      ] = await Promise.all([
        getRelojesChecadores({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasCargas({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setRelojesChecadores(_relojesChecadores);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setFechaRegistro(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _cargaConfigReloj = await getIncidenciaCarga(match.id);

    if (!relojesChecadores.length) {
      await getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }).then(setRelojesChecadores);
    }

    setTimeout(() => {
      if (_cargaConfigReloj) {
        const formValues = {
          // Formatea la información recibida (según lógica definida en formatReceived)
          ...formatReceived(_cargaConfigReloj),

          tipo_de_reloj_checador: _cargaConfigReloj.tipo_de_reloj_checador?.id,

          // Convierte la fecha de Fecha final a objeto moment si existe, si no null
          fecha_final: _cargaConfigReloj.fecha_final
            ? moment(_cargaConfigReloj.fecha_final)
            : null,

          // Asigna el ID del estado global
          estados_globales: _cargaConfigReloj.estados_globales?.id, //  aquí sí es un ID
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_cargaConfigReloj?.estados_globales?.id !== ESTATUS_ACTIVO);
          setVisible(true);
          setFechaRegistro(_cargaConfigReloj?.fecha_de_registro_en_campo_individual);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
    setFechaRegistro(false);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.fecha_final?.format) {
        values.fecha_final = values.fecha_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIncidenciaCarga(key, values) : postIncidenciaCarga(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIncidenciaCarga(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      fecha_final: record.fecha_final
        ? moment(record.fecha_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Carga ya autorizado');
        return;
      }
      const saved = await autorizarIncidenciaCarga(key);
      if (saved) {
        const _data = await getIncidenciasCargas({ estados_globales: ESTATUS_AUTORIZADO });
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Reloj Checador',
      dataIndex: 'tipo_de_reloj_checador',
      key: 'tipo_de_reloj_checador',
      width: 200,
      render: (_, record) => record?.tipo_de_reloj_checador?.nombre || 'n/a'
      ,
    },
    {
      titleText: 'Fecha de Registro en Campo Individual',
      dataIndex: 'fecha_de_registro_en_campo_individual',
      key: 'fecha_de_registro_en_campo_individual',
      width: 180,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Renglón Donde Inicia la Información',
      dataIndex: 'renglon_donde_inicia_la_informacion',
      key: 'renglon_donde_inicia_la_informacion',
      width: 180,
    },
    {
      titleText: 'Columna de Fecha de Registro',
      dataIndex: 'columna_de_fecha_de_registro',
      key: 'columna_de_fecha_de_registro',
      width: 180,
    },
    {
      titleText: 'Columna de Número de Empleado',
      dataIndex: 'columna_de_numero_de_empleado',
      key: 'columna_de_numero_de_empleado',
      width: 180,
    },
    {
      titleText: 'Columna de Nombre de Empleado',
      dataIndex: 'columna_de_nombre_de_empleado',
      key: 'columna_de_nombre_de_empleado',
      width: 180,
    },
    {
      titleText: 'Columna de Hora de Entrada',
      dataIndex: 'columna_de_hora_de_entrada',
      key: 'columna_de_hora_de_entrada',
      width: 180,
    },
    {
      titleText: 'Columna de Hora de Salida',
      dataIndex: 'columna_de_hora_de_salida',
      key: 'columna_de_hora_de_salida',
      width: 180,
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (_, record) => record?.estados_globales?.descripcion || 'n/a',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  const letras = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));

  const handleFilaNumber = (fieldName) => (e) => {
    const rawValue = e.target.value;

    // Keep only digits
    const filtered = rawValue.replace(/\D/g, '');

    // Convert to number
    const num = Number(filtered);

    // Only update if it's greater than 0
    if (num > 0) {
      form.setFieldsValue({ [fieldName]: num });
    } else {
      // If it's 0 or less, maybe clear it or set empty string
      form.setFieldsValue({ [fieldName]: '' });
    }
  };
  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'incidenciacarga', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                disabled: selectedData?.estados_globales?.id !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Carga del Reporte del Reloj Checador`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="general"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
                fecha_de_registro_y_horario_conjunto: false,
                fecha_de_registro_en_campo_individual: false,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="tipo_de_reloj_checador"
                  label="Reloj Checador"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={relojesChecadores}
                    disabled={
                      form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                      || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fecha_de_registro_en_campo_individual"
                  label="Fecha de Registro en Campo Individual"
                  rules={rules.required}
                >
                  <Select
                    trueFalse
                    disabled={
                      form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                      || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                    }
                    onChange={
                      (value) => {
                        setFechaRegistro(value);
                      }
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="columna_de_fecha_de_registro"
                  label="Columna de Fecha de Registro"
                >
                  <Select
                    dataSource={letras.map((letra) => ({ id: letra, descripcion: letra }))}
                    disabled={
                      disableFields
                      || !isFechaRegistro
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="columna_de_numero_de_empleado"
                  label="Columna de Número de Empleado"
                  rules={rules.required}
                >
                  <Select
                    dataSource={letras.map((letra) => ({ id: letra, descripcion: letra }))}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="columna_de_nombre_de_empleado"
                  label="Columna de Nombre de Empleado"
                >
                  <Select
                    dataSource={letras.map((letra) => ({ id: letra, descripcion: letra }))}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="columna_de_hora_de_entrada"
                  label="Columna de Hora de Entrada"
                  rules={rules.required}
                >
                  <Select
                    dataSource={letras.map((letra) => ({ id: letra, descripcion: letra }))}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="columna_de_hora_de_salida"
                  label="Columna de Hora de Salida"
                  rules={rules.required}
                >
                  <Select
                    dataSource={letras.map((letra) => ({ id: letra, descripcion: letra }))}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="renglon_donde_inicia_la_informacion"
                  label="Renglón Donde Inicia la Información"
                  rules={rules.required}
                >
                  <Input
                    allowClear
                    onChange={handleFilaNumber('renglon_donde_inicia_la_informacion')}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fecha_final"
                  label="Fecha Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={isAdding || selectedData?.estados_globales?.id === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales?.id === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Carga del Reporte del Reloj Checador ${form.getFieldValue('tipo_de_reloj_checador')?.nombre || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Carga del Reporte del Reloj Checador ${form.getFieldValue('tipo_de_reloj_checador')?.nombre || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Carga del Reporte del Reloj Checador ${form.getFieldValue('tipo_de_reloj_checador')?.nombre || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default CargaConfigReloj;
